import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2BulkResponsiblePersonAccept = hashCodeCertificate('WaybillV2BulkResponsiblePersonAccept')
export default WaybillV2BulkResponsiblePersonAccept